export const LABELS: any = {
  ROLE_MANAGEMENT: "Role Management",
  NAME_TEXT: "Name",
  FIRSTNAME_TEXT: "First Name",
  LASTNAME_TEXT: "Last Name",
  PHONE_TEXT: "Phone",
  EMAIL_TEXT: "Email",
  SIGNIN: "Sign In",
  EMAIL_ADDRESS_TEXT: "Email Address",
  USERNAME_TEXT: "User Name",
  PASSWORD_TEXT: "Password",
  NEW_PASSWORD_TEXT: "New Password",
  CONFIRM_PASSWORD_TEXT: "Confirm Password",
  CURRENT_PASSWORD_TEXT: "Current Password",
  RESET_PASSWORD_TEXT: "Reset Password",
  EXISTING_PASSWORD_TEXT: "Existing Password",
  ACTIVE_NAME_TEXT: "Active",
  INACTIVE_NAME_TEXT: "Inactive",
  ROLE_TEXT: "Role",
  STATE_TEXT: "State",
  STATUS_TEXT: "Status",
  USER_TYPE_TEXT: "User Type",
  ADDRESS_TEXT: "Address",
  CREATED_AT_TEXT: "Created At",
  START_DATE_TEXT: "Start Date",
  END_DATE_TEXT: "End Date",
  UPDATED_AT_TEXT: "Updated At",
  LOGIN_TEXT: "Login",
  LOGOUT_TEXT: "Logout",
  PROFILE_TEXT: "Profile",
  CUSTOMER_MANAGEMENT_TEXT: "Customer Management",
  DASHBOARD_TEXT: "Dashboard",
  INVENTORY_TEXT: "Inventory Management",
  ORDER_MANAGEMENT_TEXT: "Order Management",
  FOLLOW_UP_TEXT: "Follow Up",
  ORDER_INFORMATION_TEXT: "Order Information",
  PRODUCT_MANAGEMENT_TEXT: "Product Management",
  ROLE_MANAGEMENT_TEXT: "Role Management",
  ROLES_TEXT: "Roles",
  SALES_PERSON_TEXT: "Sales Person",
  STORE_COORDINATOR_TEXT: "Store Users",
  USERS_TEXT: "Users",
  USER_TEXT: "User",
  STORE_TEXT: "Store",
  STORE_MANAGEMENT_TEXT: "Store Management",
  USER_MANAGEMENT_TEXT: "User Management",
  USER_PROFILE_TEXT: "User Profile",
  VENDOR_MANAGEMENT_TEXT: "Vendor Management",
  EDIT_USER_TEXT: "Edit User",
  ADD_USER_TEXT: "Add User",
  ADD_ORDER_TEXT: "Add Order",
  EDIT_ORDER_TEXT: "Edit Order",
  ORDER_DETAILS_TEXT: "Order Details",
  REFERENCE_IMAGES_TEXT: "Reference Images",
  NO_IMAGES_UPLOADED_TEXT: "No reference images uploaded for this order",
  IMAGES_EXPIRED_TEXT: "Images Expired",
  DOWNLOAD_ALL_IMAGES_TEXT: "Download All Images",
  DOWNLOAD_IMAGE_TEXT: "Download Image",
  IMAGE_UPLOAD_DATE_TEXT: "Upload Date",
  IMAGE_UPLOADED_BY_TEXT: "Uploaded By",
  IMAGE_FILE_NAME_TEXT: "File Name",
  PRODUCT_DETAILS_TEXT: "Product Details",
  VENDOR_DETAILS_TEXT: "Vendor Details",
  USER_DETAILS_TEXT: "User Details",
  SALES_PERSON_DETAILS_TEXT: "Sales Persons Details",
  STORE_COORDINATOR_DETAILS_TEXT: "Store User Details",
  EDIT_STORE_COORDINATOR_TEXT: "Edit Store User",
  ADD_STORE_COORDINATOR_TEXT: "Add Store User",
  ITEM_TEXT: "Item",
  PRODUCT_BOM_DETAILS_TEXT: "Product BOM Details",
  MY_PROFILE_TEXT: "My Profile",
  PERSONAL_INFORMATION_TEXT: "Personal Information",
  CHANGE_PASSWORD_TEXT: "Change Password",
  E_MAIL_ADDRESS_TEXT: "E-Mail Address",
  DESIGNATION_TEXT: "Designation",
  CITY_TEXT: "City",
  SEARCH_TEXT: "Search",
  USER_MANAGEMENT_DETAILS_TEXT: "User Management Details",
  STORE_MANAGEMENT_DETAILS_TEXT: "Store Management Details",
  INVENTORY_MANAGEMENT_DETAILS_TEXT: "Inventory Management Details",
  CUSTOMER_DETAILS_TEXT: "Customer Details",
  REPORT_DETAILS_TEXT: "Report Details",
  CODE_TEXT: "Code",
  DIVISION_TEXT: "Division",
  SECTION_TEXT: "Section",
  DEPARMENT_TEXT: "Department",
  ARTICLE_NAME_TEXT: "Article Name",
  CATEGORY_TEXT: "Category",
  REMEMBER_ME_TEXT: "Remember Me",
  FORGOT_PASSWORD_TEXT: "Forgot Password?",
  CONFIRMATION_CODE_TEXT: "Confirmation Code",
  SALES_PERSON_NAME_TEXT: "Sales Person Name",
  PHONE_NO_TEXT: "Phone No.",
  DESIGN_NO_TEXT: "Design No.",
  ORDER_NO_TEXT: "Order No.",
  CUSTOMER_NAME_TEXT: "Customer Name",
  DELIVERY_DATE_TEXT: "Delivery Date",
  REMAINING_DAY_TEXT: "Remaining Day",
  SALUTATION_TEXT: "Salutation",
  MIDDLE_NAME_TEXT: "Middle Name",
  DISTRICT_TEXT: "District",
  PIN_TEXT: "Pin",
  MOBILE_NO_TEXT: "Mobile No.",
  REMARKS_TEXT: "Remarks",
  GST_STATE_TEXT: "GST State",
  GST_STATE_NAME_TEXT: "GST State Name",
  GST_IN_TEXT: "GSTIN",
  JOBBER_ID_TEXT: "Jobber ID",
  ALIAS_TEXT: "Alias",
  CLASS_TYPE_TEXT: "Class Type",
  CLASS_NAME_TEXT: "Class Name",
  AR_LEDGER_TEXT: "AR Ledger",
  CONTACT_PERSON_NAME_TEXT: "Contact Person Name",
  TAX_REGION_TEXT: "Tax Region",
  TRADE_GROUP_TEXT: "Trade Group",
  PURCHASE_TERM_TEXT: "Purchase Term",
  PAN_NO_TEXT: "PAN No.",
  GST_CATEGORY_TEXT: "GST Category",
  GSTIN_NO_TEXT: "GSTIN No.",
  BARCODE_TEXT: "Barcode",
  ITEM_NAME_TEXT: "Item name",
  DEPARTMENT_TEXT: "Department",
  HSN_CODE_TEXT: "HSN Code",
  SITE_STOCK_TEXT: "Site Stock",
  CUID_TEXT: "CUID",
  SHORT_CODE_TEXT: "Short Code",
  DOC_IDENTIFICATION_NO_TEXT: "Doc.Indentification No.",
  PRICE_TYPE_TEXT: "Price Type",
  SITE_TYPE_TEXT: "Site Type",
  ORGANIZATION_UNIT_TEXT: "Organization Unit",
  STORE_SIZE_TEXT: "Store Size",
  SYNC_DATE_AND_TIME_TEXT: "Sync Date and Time",
  EMAIL_ID_TEXT: "Email Id",
  STRING_DESC_TEXT: "String Desc",
  MATERIAL_TYPE_TEXT: "Material-Type",
  UOM_TEXT: "UOM",
  MRP_TEXT: "MRP",
  RSP_TEXT: "RSP",
  WSP_TEXT: "WSP",
  LAST_MODIFIED_ON_TEXT: "Last Modified On",
  LAST_INWARD_RATE_TEXT: "Last Inward Rate",
  STANDARD_RATE_TEXT: "Standard Rate",
  CLOSING_QTY_TEXT: "Closing QTY",
  LAST_STOCK_INWARD_DATE_TEXT: "last stock inward date",
  CREATED_ON_TEXT: "Created On",
  FULLNAME_TEXT: "Full Name",
  STOCK_POINT_TEXT: "Stock Point",
  MOBILE_TEXT: "Mobile",
  TARGET_SALES_TEXT: "Target sales",
  CUSTOMER_TEXT: "Customer",
  SHIPPING_CONTACT_PERSON_TEXT: "Shipping Contact Person",
  BILLING_CITY_TEXT: "Billing City",
  BILLING_OFFICE_PHONE_1_TEXT: "Billing Office Phone 1",
  BILLING_CONTACT_PERSON_TEXT: "Billing Contact Person",
  BILLING_EMAIL_1_TEXT: "Billing Email 1",
  COMPANY_TYPE_TEXT: "Company_Type",
  INDUSTRY_TYPE_TEXT: "Industry_Type",
  IDENTITY_NO_TEXT: "Identity No",
  EDIT_CUSTOMER_TEXT: "Edit Customer",
  ADD_CUSTOMER_TEXT: "Add Customer",
  REPORT_TEXT: "Reports",
  ALREADY_HAVE_AN_ACOUNT_TEXT: "Already Have An Account ?",
  ITEM_CODE_TEXT: "Item Code",
  DESTINATION_SITE_TEXT: "Destination Site",
  SIZE_TEXT: "Size",
  ORDER_DATE_TEXT: "Order Date",
  FABRIC_CODE_TEXT: "Fabric Code",
  I_CODE_TEXT: "I Code",
  COLOR_TEXT: "Color",
  PRICE_TEXT: "Price",
  SO_NO_TEXT: "S.O No.",
  QTY_TEXT: "Qty",
  ISD_CODE_TEXT: "ISD Code",
  GENDER_TEXT: "Gender",
  DOB_TEXT: "DOB",
  RECIEVE_MESSAGE_TEXT: "Recieve Message",
  PREF_COMMUNICATION_MODE_TEXT: "Pref Communication Mode",
  SITE_CODE_TEXT: "Site Code",
  NOT_FOUND_TEXT: "Not Found",
  CUSTOMER_INFORMATION_TEXT: "Customer Information",
  SUB_ASSEMBLY_ITEM_TEXT: "Sub Assembly item",
  TRACKING_INFORMATION_TEXT: "Tracking Information",
  CUS_TEXT: "Cus.",
  SR_NO_TEXT: "Sr. No.",
  D_NO_TEXT: "D. No.",
  DATE_TEXT: "Date",
  No_DATA_FOUND_TEXT: "No Data Found",
  POPULATE_TEXT: "Populate",
  PRINT_ORDER_TEXT: "Print Order",
  CONFIRM_TEXT: "Confirm",
  CONFIRMED_TEXT: "Confirmed",
  COMPLETED_TEXT: "Complete",
  PENDING_TEXT: "Pending",
  CONFIRMATION_PENDING_TEXT: "Confirmation Pending",
  CONFIRM_IN_PROGRESS_TEXT: "Confirmation in progress",
  APPROVAL_PENDING_TEXT: "Approval Pending",
  CANCEL_TEXT: "Cancel",
  CANCELED_TEXT: "Canceled",
  ON_HOLD_TEXT: "On Hold",
  PRINT_ALL_TEXT: "Print All",
  DELETE_TEXT: "Are you sure you want to delete?",
  DELETE_USER_TEXT: "Delete User",
  DELETE_ROLE_TEXT: "Delete Role",
  DELETE_STORE_COORDINATOR_TEXT: "Delete Store User",
  SUMMARY_DETAIL_TEXT: "Summary detail",
  REASON_TEXT: "Reason",
  PRINT_ORDER_TITLE_TEXT: "NM Fashion Designs Pvt. Ltd",
  PRINT_ORDER_HOUSE_ADDRESS_TEXT:
    "NM House, Plot No.9(1), Service Road, Cama Industrial Estate,",
  PRINT_ORDER_ADDRESS_TEXT: " Goregaon (East), Mumbai - 400 063",
  PRINT_ORDER_PHONE_TEXT: "PH : 022 - 62775888",
  SELECT_TEXT: "Select",
  FILTER_TEXT: "Filter",
  ITEM_DETAIL_TEXT: "Item Detail",
  ITEM_STOCK_TEXT: "Item Stock",
  CONFIRM_ORDERS_TEXT: "Confirmed Orders",
  CANCELLED_ORDERS_TEXT: "Cancelled Orders",
  PENDING_ORDERS_TEXT: "Pending Orders",
  TOTAL_ORDERS_TEXT: "Total Orders",
  TOTAL_USERS_TEXT: "Total Users",
  TOTAL_STORE_USERS_TEXT: "Total Store Users",
  SHOWING_TEXT: "Showing",
  ENTRIES_TEXT: "entries",
  SHOW_TEXT: "Show ",
  CANCEL_DETAILS_TEXT: "Cancel Details",
  CANCEL_CODE_TEXT: "Cancel Code",
  CANCEL_NO_TEXT: "Cancel No",
  DOCUMENT_NO_TEXT: "Document No",
  CHECKER_ID_TEXT: "Checker Id",
  ITEM_DETAILS_TEXT: "Item Details",
  ITEM_STATUS_TEXT: "Item Status",
  STORE_DELIVERY_DATE_TEXT: "Store Delivery Date",
  CUSTOMER_DELIVERY_DATE_TEXT: "Customer Delivery Date",
  ADVANCE_PAYMENT_INFORMATION_TEXT: "Advance Payment Information",
  AMOUNT_TEXT: "Amount",
  PRINT_CONFIRMATION_TEXT: "Print Confirmation",
  PRINT_COUNT_TEXT: "Print Count",
  STORE_CODE_TEXT: "Store Code",
  DISPATCH_DATE_TEXT: "Dispatch Date",
  CREATED_BY_TEXT: "Created By",
  LAST_MODIFIED_BY_TEXT: "Last Modified By",
  LAST_MODIFIED_AT_TEXT: "Last Modified At",
  ORDER_INFO_TEXT: "Order Info",
  ON_TEXT: "on",
  AT_TEXT: "at",
  EM_DASH_TEXT: "—",
  ADVANCE_AMOUNT_TEXT: "Advance Amount",
  ADVANCE_REMARKS_TEXT: "Advance Remark",
  USERCODE_TEXT: "User Code",
  BACKOFFICE_USERS_TEXT: "Backoffice Users",
  STORE_CASHIER_TEXT: "Store Cashiers",
  STORE_CO_ORDINATOR_TEXT: "Store Coordinators",
  CUSTOM_TEXT: "Custom",
  LIST_OF_CUSTOM_ITEM_TEXT: "List of Custom Items",
  CUSTOM_ITEMS_IN_ORDER_TEXT: "Custom Items in Order",
  CONFIRM_DETAILS_TEXT: "Confirm Details",
  CONFIRMED_BY_TEXT: "Confirmed By",
  CONFIRMED_AT_TEXT: "Confirmed At",
  APPROVED_BY_TEXT: "Approved By",
  APPROVAL_AT_TEXT: "Approval At",
  APPROVAL_TAT_TEXT: "Approval TAT",
  CANCEL_TAT_TEXT: "Cancel TAT",
  CANCELLED_BY_TEXT: "Cancelled By",
  CANCELLED_AT_TEXT: "Cancelled At",
  CUSTOMER_FEEDBACK_TEXT: "Customer Feedback",
  RATE_TEXT: "Rate",
  CUSTOMER_MOBILE_NO_TEXT: "Customer Mobile No",
  ACTIONS_TEXT: "Actions",
  OOPS_TEXT: "oops",
  UTILITY_TEXT: "Utility",
  STORE_EXEMPTED_TEXT: "Stores Exempted from sending Orders to Ginesys",
  STORE_NAME_TEXT: "Store Name",
  FABRIC_STOCK_SETTINGS_TEXT: "Fabric Stock Settings",
  FABRIC_WARNING_LOG_TEXT: "Fabric Warning Log",
  THRESHOLD_TEXT: "Threshold (meters)",
  AVAILABLE_STOCK_TEXT: "Available Stock",
  USER_DECISION_TEXT: "User Decision",
  DECIDED_AT_TEXT: "Decided At",
  DATA_AS_OF_TEXT: "Stock data as of",
  LAST_CHANGED_BY_TEXT: "Last changed by",
  LAST_CHANGED_AT_TEXT: "on",
  ORDER_COMMUNICATION_TEXT: "Order Communication",
  NO_COMMENTS_TEXT: "No comments yet.",
  COMMENTS_TEXT: "Comments",
  COMMENT_PLACEHOLDER_TEXT: "Type a comment…",
  SEND_TEXT: "Send",
  ATTACH_IMAGE_TEXT: "Attach Image",
  COMMENT_READONLY_TEXT: "Comments are now read-only — order has been dispatched",
  CHAT_STORE_INITIATE_REQUIRED_TEXT: "Chat must be initiated by the store from the mobile app.",
  COMMENT_UNCONFIRMED_TEXT: "Chatting is available only after order confirmation",
  IMPORTANT_TEXT: "Important",
  IMPORTANT_INFO_TEXT:
    "Important comments are printed on the Warehouse Order Copy",
  ROLE_STORE_TEXT: "Store",
  ROLE_BACK_OFFICE_TEXT: "Back Office",
  IMAGE_EXPIRED_TEXT: "Image Expired",
  ADMIN_EDIT_TITLE_TEXT: "Manual Edit",
  ENABLE_EDITING_TEXT: "Enable Editing",
  CANCEL_EDITING_TEXT: "Cancel Editing",
  SAVE_CHANGES_TEXT: "Save Changes",
  ADMIN_EDIT_WARNING_TEXT:
    "Changes saved locally only. Ginesys will NOT be updated automatically.",
  AUDIT_TRAIL_TEXT: "Audit Trail",
  VIEW_AUDIT_TRAIL_TEXT: "View Audit Trail",
  FIELD_NAME_TEXT: "Field Name",
  PREVIOUS_VALUE_TEXT: "Previous Value",
  NEW_VALUE_TEXT: "New Value",
  CHANGED_BY_TEXT: "Changed By",
  CHANGED_AT_TEXT: "Changed At",
  TIMESTAMP_TEXT: "Timestamp",
  SHOW_MORE_TEXT: "Show More",
  SHOW_LESS_TEXT: "Show Less",
  NO_AUDIT_ENTRIES_TEXT: "No audit entries for this order",
  AUDIT_TRAIL_CONFIG_TEXT: "Audit Trail Configuration",
  AUDIT_CONFIG_WARNING_TEXT:
    "Changes apply to future order modifications only",
  CUSTOMER_FEEDBACK_LIST_TEXT: "Customer Feedback",
  FEEDBACK_FORM_CONFIG_TEXT: "Feedback Form Configuration",
  RATING_QUESTIONS_TEXT: "Rating Questions",
  COMMENT_FIELDS_TEXT: "Comment Fields",
  RATING_SUMMARY_TEXT: "Rating Summary",
  COMMENT_PREVIEW_TEXT: "Comment Preview",
  NO_FEEDBACK_SUBMISSIONS_TEXT: "No feedback submissions found.",
  LOW_RATED_TEXT: "Low Rated",
  SUBMITTED_BY_TEXT: "Submitted By",
  SUBMITTED_AT_TEXT: "Submitted At",
  QUESTION_TEXT: "Question Text",
  DISPLAY_ORDER_TEXT: "Display Order",
  CHARACTER_LIMIT_TEXT: "Character Limit",
  FIELD_LABEL_TEXT: "Field Label",
  LABEL_HINT_TEXT: "Label Hint",
  CONFIG_APPLIES_TO_NEW_TEXT: "Changes apply only to new feedback submissions",
  MAX_ACTIVE_QUESTIONS_TEXT: "Maximum 5 active questions allowed",
  MIN_ACTIVE_QUESTIONS_TEXT: "At least one active rating question is required",
  MIN_ACTIVE_COMMENT_FIELDS_TEXT: "At least one active comment field is required",
  EXPORT_TO_CSV_TEXT: "Export to CSV",
  EXPORT_TO_EXCEL_TEXT: "Export to Excel",
  MOVE_UP_TEXT: "Move Up",
  MOVE_DOWN_TEXT: "Move Down",
  ADD_QUESTION_TEXT: "Add Question",
  EDIT_QUESTION_TEXT: "Edit Question",
  ADD_FIELD_TEXT: "Add Comment Field",
  EDIT_FIELD_TEXT: "Edit Comment Field",
  OPERATOR_TEXT: "Operator",
  RATINGS_TEXT: "Ratings",
  AVERAGE_RATING_TEXT: "Average Rating",
  WHATSAPP_STAGES_TEXT: "WhatsApp Notifications",
  WHATSAPP_TEMPLATES_TEXT: "WhatsApp Templates",
  WHATSAPP_LOG_TEXT: "WhatsApp Communication Log",
  STAGE_NAME_TEXT: "Stage Name",
  STAGE_KEY_TEXT: "Stage Key",
  NOTIFICATION_TEXT: "Notification",
  ENABLED_TEXT: "Enabled",
  DISABLED_TEXT: "Disabled",
  DEFAULT_ON_TEXT: "Default On",
  TEMPLATE_BODY_TEXT: "Template Body",
  PLACEHOLDERS_TEXT: "Placeholders",
  INTERAKT_TEMPLATE_NAME_TEXT: "Interakt Template Name",
  PARAMETER_ORDER_TEXT: "Parameter Order",
  PREVIEW_TEXT: "Preview",
  CONTACT_NUMBER_TEXT: "Contact Number",
  ORDER_NUMBER_TEXT: "Order Number",
  MESSAGE_TYPE_TEXT: "Message Type",
  JOB_STATE_TEXT: "Job State",
  DELIVERY_STATUS_TEXT: "Delivery Status",
  PROVIDER_MESSAGE_ID_TEXT: "Provider Message ID",
  RETRY_COUNT_TEXT: "Retry Count",
  ERROR_TEXT: "Error",
  CHARACTER_COUNT_TEXT: "Character Count",
  MISSING_PLACEHOLDERS_TEXT: "Missing Placeholders",
};

export const BUTTON_LABEL = {
  ADD: "Add",
  YES: "Yes",
  NO: "No",
  CANCEL: "Cancel",
  VIEW: "View",
  EDIT: "Edit",
  DELETE: "Delete",
  SAVE: "Save",
  SEARCH: "Search",
  DOWNLOAD: "Download",
  EXPORT: "Export",
  IMPORT: "Import",
  PRINT: "Print",
  SIGNIN: "Sign In",
  UPDATE: "update",
  FILTER: "Filter",
  RESET_FILTER: "Reset Filter",
  CHANGE_PASSWORD: "Change Password",
  REQUEST_PASSWORD: "Request Password",
  VALIDATE_OTP: "Validate OTP",
  LOGIN: "Login",
  SEND_OTP: "Send Otp",
  SUBMIT: "Submit",
  ADD_ROLE: "Add Role",
  CLOSE: "Close",
  CONFIRM: "Confirm",
  EDIT_ORDER: "Edit Order",
  SAVE_ORDER: "Save Order",
  SAMPLE_CSV: "Sample CSV",
  COLUMN_CONFIGURATION: "Column Configuration",
  DOWNLOAD_PDF: "Download the PDF",
  PRINT_TRANSACTION: "Print Transaction",
  POPULATE: "Populate",
  APPLY: "Apply",
  RESET: "Reset",
  CONFIRM_IN_PROGRESS: "Confirm In Progress",
  CONFIRM_ORDER: "Confirm Order",
  CANCEL_ORDER: "Cancel Order",
  OK: "Ok",
  SEND: "Send",
  ENABLE_EDITING: "Enable Editing",
  CANCEL_EDITING: "Cancel Editing",
  SAVE_CHANGES: "Save Changes",
};

export const TOAST_MESSAGE = {
  RECORD_NOT_FOUND: "The record you are looking for was not found.",
  KEY_COPIED: "key copied to clipboard.",
  USER_PROFILE_UPDATED: "User Profile updated successfully.",
  USER_UPDATED: "User updated successfully.",
  USER_DELETED: "User deleted successfully.",
  USER_CREATED: "User added successfully.",
  ROLE_UPDATED: "Role updated successfully.",
  ROLE_DELETED: "Role deleted successfully.",
  ROLE_CREATED: "Role added successfully.",
  EMAIL_NOT_MATCH: "Email / Mobile Number doesn't matched.",
  OTP_VALID: "OTP validated successfully.",
  OTP_NOT_VALID: "OTP not valid ",
  INVALID_PASSWORD: "Invalid Password",
  PASSWORD_DOES_NOT_MATCH:
    "The password you entered doesn't match the password in the system.",
  PASSWORD_UPDATED: "Password has been updated successfully.",
  FORBIDDEN_ACCESS: "Forbidden access.",
  PERMISSION_REQUIRED: "Please Select atleast one Role .",
  FILE_DOWNLOAD: "File downloaded successfully.",
  PHOTO_UPLOADED: "Image uploaded successfully.",
  CSV_IMPORTED: "CSV imported successfully.",
  CSV_EXPORTED: "CSV exported successfully.",
  STORE_CREATED: "Store added Successfully.",
  LOGIN: "Successfully Logged In",
  LOGOUT: "You have successfully logged out",
  SALES_PERSON_UPDATED: "Sales Person updated successfully.",
  STORE_COORDINATOR_CREATED: "Store Coordinator created successfully.",
  STORE_COORDINATOR_UPDATED: "Store Coordinator updated successfully.",
  STORE_COORDINATOR_DELETED: "Store Coordinator deleted successfully.",
  CUSTOMER_UPDATED: "Customer updated successfully.",
  CUSTOMER_FEEDBACK_RATING_MESSAGE:
    "Please give at least 1 star to submit feedback.",
  COMMENT_ADDED: "Comment added successfully.",
  COMMENT_MARKED_IMPORTANT: "Comment marked as important.",
  COMMENT_UNMARKED_IMPORTANT: "Comment unmarked as important.",
  ADMIN_EDIT_SAVED: "Changes saved locally. Please update Ginesys separately.",
  WHATSAPP_STAGE_TOGGLED: "Notification status updated successfully.",
  WHATSAPP_TEMPLATE_UPDATED: "Template updated successfully.",
  WHATSAPP_LOG_EXPORTED: "WhatsApp log exported successfully.",
  WHATSAPP_PREVIEW_FAILED: "Unable to generate preview.",
};

export const PAGE_TITLE = {};

export const MESSAGE = {
  DELETE_MESSAGE: "Are you sure, you want to delete ",
  TITLE_TEXT: "A royal fusion of modern and ethnic wear for all occasions",
  PRINT_MESSAGE: "Are you sure, you want to print ?",
  CONFIRM_ORDER_MESSAGE: "Are you sure, you want to confirm order ?",
  CUSTOM_ORDER_ITEM_MESSAGE:
    "There are custom items in the order. Please update them to confirm the order.",
  CUSTOMER_FEEDBACK_TEMPLATE_MESSAGE: "Your feedback is valuable to us",
  ORDER_NOT_FOUND_MESSAGE: "The order you are looking for is not found",
  FEEDBACK_SUBMIT_MESSAGE: "Your feedback has been submitted successfully.",
};

export const ERROR_MESSAGE = {
  NAME_REQUIRED: "Name is required.",
  FIRST_NAME_REQUIRE: "First Name is required.",
  MIDDLE_NAME_REQUIRE: "Middle Name is required.",
  FULL_NAME_REQUIRE: "Full Name is required.",
  LAST_NAME_REQUIRE: "Last Name is required.",
  USER_NAME_REQUIRE: "User Name is required.",
  USER_CODE_REQUIRE: "User Code is required.",
  EMAIL_REQUIRE: "E-Mail is required.",
  EMAIL_ADDRESS_REQUIRE: "E-Mail Address is required.",
  PASSWORD_REQUIRE: "Password is required.",
  CONFIRM_PASSWORD_REQUIRE: "Confirm Password is required.",
  EXISTING_PASSWORD_REQUIRE: "Existing Password is required",
  CODE_REQUIRED: "Code is required.",
  ADDRESS_REQUIRED: "Address is required.",
  ADDRESS_1_REQUIRED: "Address 1 is required.",
  ADDRESS_2_REQUIRED: "Address 2 is required.",
  ROLE_REQUIRE: "Role is required.",
  NAME_MIN_LENGTH: "Name must be more than 4 characters!",
  NAME_MAX_LENGTH: "Name cannot exceed more than 50 characters!",
  PHONE_REQUIRE: "Phone is required.",
  MOBILE_REQUIRE: "Mobile is required.",
  NAME_REGEX_MESSAGE: "Name must be alphabetic.",
  FULLNAME_REGEX_MESSAGE: "Full Name must be alphabetic.",
  DESCRIPTION_REGEX_MESSAGE: "Description only allows alphabets and numbers.",
  KEY_REGEX_MESSAGE: "Key must be alphabetic",
  VALUE_REGEX_MESSAGE: "Value must be alphabetic",
  EMAIL_REGEX_MESSAGE: "Enter valid E-mail.",
  EMAIL_ADDRESS_REGEX_MESSAGE: "Enter valid E-Mail address.",
  CONTACT_NUMBER_REGEX_MESSAGE: "Enter valid contact number.",
  PASSWORD_AND_CONFIRM_PASSWORD_MESSAGE:
    "password and confirm password must be same.",
  OTP_REQUIRED: "otp required.",
  PHONE_REGEX_MESSAGE: "Enter valid phone number.",
  MOBILE_NO_REGEX_MESSAGE: "Enter valid mobile no.",
  USER_TYPE_REQUIRED: "User Type is required.",
  STORE_REQUIRE: "Store is required.",
  DESIGNATION_REQUIRED: "Designation is required.",
  STATE_REQUIRED: "State is required.",
  CITY_REQUIRED: "City is required.",
  PERMISSION_REQUIRED: "Permission is required.",
  SALUTATION_REQUIRE: "Salutation is required.",
  DISTRICT_REQUIRED: "District is required.",
  PIN_REQUIRED: "Pin is required.",
  REMARKS_REQUIRED: "Remarks is required",
  GST_STATE_NAME_REQUIRED: "GST State Name is required",
  GST_IN_REQUIRED: "GSTIN is required",
  ISD_CODE_REQUIRED: "ISD Code is required.",
  GENDER_REQUIRED: "Gender is required.",
  DOB_REQUIRED: "DOB is required.",
  RECEIVED_MESSAGE_REQUIRED: "Received Message is required.",
  PREF_COMMUNICATION_MODE_REQUIRED: "Pref Communication Mode is required.",
  SITE_CODE_REQUIRED: "Site Code is required.",
  THRESHOLD_REQUIRED: "Threshold is required.",
  THRESHOLD_POSITIVE: "Threshold must be a positive number.",
  COMMENT_REQUIRED: "Comment text or an image is required.",
  MAX_IMAGES_EXCEEDED: "Maximum 2 images allowed per comment.",
  IMAGE_TYPE_INVALID: "Only JPG, JPEG or PNG images are allowed.",
  IMAGE_SIZE_EXCEEDED: "Image size must be 5 MB or less.",
  QUESTION_TEXT_REQUIRED: "Question text is required.",
  DISPLAY_ORDER_REQUIRED: "Display order is required.",
  FIELD_LABEL_REQUIRED: "Field label is required.",
  CHARACTER_LIMIT_REQUIRED: "Character limit is required.",
  CHARACTER_LIMIT_POSITIVE: "Character limit must be a positive number.",
};

export const REGULAR_EX = {
  name: /^[a-zA-z ]{2,}$/,
  NAME_REGEX: /^[a-zA-z .,_-]{1,}$/,
  EMAIL_REGEX:
    /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i,
  PHONE_REGEX: /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
  WHITE_SPACE_WITH_TEXT: /^(?! )[A-Za-z 0-9]{3,}$/,
  ONLY_WHITE_SPACE: /^\S*$/,
  ALPHANUMBERIC_REGEX: /^[a-zA-Z0-9\s]+$/,
  USERNAME_REGEX: /^[a-z]+([\w]+){5,20}$/,
};

export const INPUT_TYPES = {
  TEXT: "text",
  BUTTON: "button",
  CHECKBOX: "checkbox",
  NUMBER: "number",
  USERNAME: "username",
  PASSWORD: "password",
  SUBMIT: "submit",
};
